module.exports = __webpack_public_path__ + "static/img/1.0b6e6bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/eng/1.png
// module id = Myyz
// module chunks = 0